// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__2mNOh","modal":"Modal_modal__Z3yfq","slide-down":"Modal_slide-down__5Xqtu"};